import Axios from 'axios';
import { useMutation } from '@tanstack/vue-query';

export default function useDeleteFromCartMutation() {
  return useMutation({
    mutationFn: (itemId) => Axios.delete(`/api/cart/item/${itemId}`),
  });
}
